import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import ClientSolvencyRequest from "../_shark_models/ClientSolvencyRequest";
import ManagerBase from "./ManagerBase";

class ClientSolvencyRequestManager extends ManagerBase {
	constructor () {
		super("clientSolvencyRequestManager");
		this.remoteClassName = "client-solvency-request";
		this.localClassReference = ClientSolvencyRequest;
	}

	async getFilteredList ({incrementalRequest, filters, range} = {incrementalRequest: false, filters: null, range: null}) {
		return super.getFilteredList("clientSolvencyRequestList", ClientSolvencyRequest, {incrementalRequest, filters, range});
	}

	async saveClientSolvencySettings (clientSolvencyRequest) {
		const rd = NousCore.api.createRequest({ item: clientSolvencyRequest.export() });
		const action = "save-client-solvency-settings";

		return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						clientSolvencyRequest.clean();
	
						return {
							data: clientSolvencyRequest,
							requestedAction: action,
							status: "ok"
						};
					case 99:
						return {
							data: "",
							requestedAction: action,
							status: "ko"
						};
				}
			}
		});
	}


}

const clientSolvencyRequestManager = new ClientSolvencyRequestManager();

Shark.registerController(clientSolvencyRequestManager);

export default clientSolvencyRequestManager;
